import axios from "axios";
import { api } from "../config";
import qs from "qs";

// default
axios.defaults.baseURL = api.REAPI_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = JSON.parse(localStorage.getItem("authUser"))
  ? JSON.parse(localStorage.getItem("authUser")).accessToken
  : null;
if (token) axios.defaults.headers.common["token"] = "Bearer " + token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Сервер холболтын алдаа гарлаа!";
        break;
      case 400:
        message = "Нэвтрэх нэр/нууц үг буруу байна!";
        break;
      case 401:
        message = "Нэвтрэх эрх байхгүй байна!";
        break;
      case 404:
        message = "Хуудас олдсонгүй!";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };

  get = (url, config = {}) => {
    return axios.get(url, {
      ...config,
      params: config.params || {},
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "comma" }),
    });
  };

  // get = (url, params) => {
  //   let response;

  //   let paramKeys = [];

  //   if (params) {
  //     Object.keys(params).map((key) => {
  //       paramKeys.push(key + "=" + params[key]);
  //       return paramKeys;
  //     });

  //     const queryString =
  //       paramKeys && paramKeys.length ? paramKeys.join("&") : "";
  //     response = axios.get(`${url}?${queryString}`, params);
  //   } else {
  //     response = axios.get(`${url}`, params);
  //   }

  //   return response;
  // };
  /**
   * post given data to url
   */
  create = (url, data, config = {}) => {
    return axios.post(url, data, config); // ✅ now config is defined
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");

  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
